import React, {useState} from 'react';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";

const FrequentlyTopics = ({onClick}) => {
  const [show, setShow] = useState();

  const accordionHandler = (option) => {
    if (option === show) {
      setShow(null);
    } else {
      setShow(option);
    }
  };

  const trackClick = async (e) => {
    e.preventDefault();
    await analytics.track('CTA_FAQs', {
      'Page Name': 'Seller Page',
    });
    window.location.href = e.target.href;
  }

  return(
    <div className="step">
      <div className="step-content" id="frequent-topics">
        <h4>Frequently looked up topics</h4>
        {/** <Accordion flush toggle={accordionHandler} open={show}>
          <AccordionItem className={show === "1" ? 'active' : null}>
            <AccordionHeader targetId="1">
              I don't see my bank in the list of banks for depositing funds
            </AccordionHeader>
            <AccordionBody accordionId="1">
              If you don't see your bank name or logo in the list of bank accounts for validation, please
              do a search by entering your bank name in the search bar and select your bank from
              the returned values.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem className={show === "2" ? 'active' : null}>
            <AccordionHeader targetId="2">
              Why does PayOnDelivery ask for my Payment Cards?
            </AccordionHeader>
            <AccordionBody accordionId="2">
              If you don't see your bank name or logo in the list of bank accounts for validation, please
              do a search by entering your bank name in the search bar and select your bank from
              the returned values.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem className={show === "3" ? 'active' : null}>
            <AccordionHeader targetId="3">
              The item you purchased was not delivered/was not shipped
            </AccordionHeader>
            <AccordionBody accordionId="3">
              If you don't see your bank name or logo in the list of bank accounts for validation, please
              do a search by entering your bank name in the search bar and select your bank from
              the returned values.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem className={show === "4" ? 'active' : null}>
            <AccordionHeader targetId="4">
              Shipping Rates & Transit Times
            </AccordionHeader>
            <AccordionBody accordionId="4">
              If you don't see your bank name or logo in the list of bank accounts for validation, please
              do a search by entering your bank name in the search bar and select your bank from
              the returned values.
            </AccordionBody>
          </AccordionItem>

          <AccordionItem className={show === "5" ? 'active' : null}>
            <AccordionHeader targetId="5">
              Available Shipping Services
            </AccordionHeader>
            <AccordionBody accordionId="5">
              If you don't see your bank name or logo in the list of bank accounts for validation, please
              do a search by entering your bank name in the search bar and select your bank from
              the returned values.
            </AccordionBody>
          </AccordionItem>
        </Accordion> **/}

        <a href="https://help.payondelivery.com" className="btn btn-pod btn-third btn-block" onClick={trackClick}>
          Frequently Asked Questions
        </a>
      </div>
    </div>
  )
}

export default FrequentlyTopics;
